const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/case.ts';
import Imm from 'immutable';
import { selectCaseRecordsRoot, casesMapRoot } from '@cistec/common_web/selectors/casesSelectors';
import { createSelector } from 'reselect';
import { useRemoteData } from '@cistec/common_web/hooks/useRemoteData';
import { loadCases } from 'App/actions/case';
import { PatAppStoreState } from './setup/rootReducer';
import { getPatNrFromSession } from 'App/utils/sessionStorage';

const emptyList = Imm.List<any>();
const emptyMap = Imm.Map<string, any>();

export const casesOfCurPat = createSelector(
    [selectCaseRecordsRoot, casesMapRoot],
    (caseRecordsRoot: Imm.Map<string, any>, casesMapRoot: Imm.Map<string, any>): Imm.List<any> => {
        let result = emptyList;
        const patNr = getPatNrFromSession();
        if (patNr && caseRecordsRoot && casesMapRoot) {
            result = (casesMapRoot.getIn([patNr, 'data']) ?? emptyMap)
                .map((_val: any, fallnr: string) => caseRecordsRoot.get(fallnr))
                .filter((rec: Imm.Map<string, any>) => !!rec)
                .toList();
        }

        return result;
    }
);

export const isLoadingCasesOfCurPat = createSelector([casesMapRoot], (casesMapRoot: Imm.Map<string, any>): boolean => {
    const patNr = getPatNrFromSession();
    return !!patNr && !!casesMapRoot && !!casesMapRoot.getIn([patNr, 'loading']);
});

const shouldFetchCases = createSelector([casesOfCurPat], (cases: Imm.List<any>): boolean => {
    const patNr = getPatNrFromSession();
    const hasPatNr = !!patNr;
    const hasCases = !!cases && cases.size > 0;
    return hasPatNr && !hasCases;
});

const selectCases = (state: PatAppStoreState) => state.cases.get('cases');

export const makeSelectCase = (fallNr: string) => createSelector([selectCases], cases => cases?.get(fallNr)?.toJS());

export function useCaseData(fallNr: string) {
    return useRemoteData({}, () => ({
        isLoading: isLoadingCasesOfCurPat,
        select: makeSelectCase(fallNr),
        shouldFetch: state => {
            return shouldFetchCases(state) && !isLoadingCasesOfCurPat(state);
        },
        fetch: (dispatch, state) => {
            const patnr = getPatNrFromSession();
            dispatch(loadCases(patnr, true));
        },
        noRefetch: true,
    }));
}
